export default {
    okText: '确定',
    dismissText: '取消',
    extra: '请选择'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/picker/locale/zh_CN.js
// module id = 385
// module chunks = 0